// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3MU9S","buttons":"PendingPaymentAlert_buttons__Em6Uz"};